import React, { useEffect, useState, useRef } from "react";
import Helper from "helper/Common_Helper";
import dayjs from 'dayjs';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import { useLocation } from 'react-router-dom';

dayjs.extend(isSameOrAfter);

function TreesDataViewTable({ TableData, currentPage, totalPages, handlePageChange }) {
    const [loading, setLoading] = useState(false);
    const location = useLocation();
    const [eventsData, setEventsData] = useState([]);
    const [participantsTotal, setParticipantsTotal] = useState(0);
    const [schoolTotal, setSchoolTotal] = useState(0);
    const [themeTotal, setThemeTotal] = useState(0);
    const [subthemeTotal, setSubThemeTotal] = useState(0);
    const [exportTotal, setExportTotal] = useState(0);
    const [exportTotalDistrict, setExportTotalDistrict] = useState(0);
    const today = dayjs().startOf('day');
    const hasFetchedTotal = useRef(false);  

    const params = new URLSearchParams(location.search);
    let storedState = params.get('state');

    if (!storedState || storedState === 'null') {
        storedState = localStorage.getItem('filterDataState');
    }
    if (!storedState) {
        // console.log("State not found in URL or localStorage.");
    }
    
    useEffect(() => {
        setEventsData(TableData);
    }, [TableData]);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };
    scrollToTop();

useEffect(() => {
    if (hasFetchedTotal.current) return;

    const fetchDataForDistrict = async (district) => {
        try {
            const response = await fetch('https://ecoclubs.education.gov.in/api/ekped-all', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ district }),
            });
            const data = await response.json();

            if (data.status === 'success') {
                setParticipantsTotal(data.totalParticipantsCount);
                setSchoolTotal(data.totalSchools);
                setThemeTotal(data.totalThemes);
                setSubThemeTotal(data.totalSubthemes);
                setExportTotalDistrict(data.data);

                hasFetchedTotal.current = true;
            } else {
                console.error("Failed to fetch district data:", data);
            }
        } catch (error) {
            console.error('Error fetching data for district:', error);
        }
    };

    const fetchDataForState = async (state) => {
        try {
            const response = await fetch('https://ecoclubs.education.gov.in/api/ekped-all', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ state }),
            });
            const data = await response.json();

            if (data.status === 'success') {
                setParticipantsTotal(data.totalParticipantsCount);
                setSchoolTotal(data.totalSchools);

                setExportTotal(data.data);

                hasFetchedTotal.current = true;
            } else {
                console.error("Failed to fetch state data:", data);
            }
        } catch (error) {
            console.error('Error fetching data for state:', error);
        }
    };

    if (eventsData.length > 0) {
        const firstDistrict = eventsData[0]?.district;
        const firstState = eventsData[0]?.state;

        let isSameDistrict = true;
        let isSameState = true;

        for (let i = 1; i < eventsData.length; i++) {
            if (eventsData[i]?.district !== firstDistrict) {
                isSameDistrict = false;
            }
            if (eventsData[i]?.state !== firstState) {
                isSameState = false;
            }
            if (!isSameDistrict && !isSameState) {
                break;
            }
        }

        if (isSameDistrict) {
            fetchDataForDistrict(firstDistrict);
        } else if (isSameState) {
            fetchDataForState(firstState);
        }
    }
}, [eventsData, location.state, storedState]);
  
const downloadCSV = () => {
    if (!eventsData || eventsData.length === 0) {
        alert("No data to export.");
        return;
    }

    const headers = ["S.no", "UDISE_ID", "School Name", "District", "Block/Ward no.", "No. of Trees"];
    const csvRows = [headers.join(",")];

    eventsData.forEach((item, index) => {
        const row = [
            (currentPage - 1) * 10 + index + 1,
            item.udiseId || "N/A",
            `"${item.schoolName || "-"}"`, // Quotes around to handle commas in name
            `"${item.district || "-"}"`,
            `"${item.blockName || "-"}"`,
            item.numberOfTrees || 0,
        ];
        csvRows.push(row.join(","));
    });

    const csvContent = csvRows.join("\n");
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "trees_data.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};


    return (
        
        <>
           {loading && (
            <div className="loader-overlay">
              <div className="spinner"></div>
            </div>
          )}
           <div className="content">
    <div className="btmTableDivIn">
        <div className="tableTopDiv">
            <div className="dwnldexel">
                <button onClick={downloadCSV} className="btn btn-primary">Download CSV</button>
            </div>
            <div className="table-responsive" style={{ maxHeight: '500px', overflowY: 'auto' }}>
                <table rules="all" className="table">
                    <thead className="text-primary" style={{ position: 'sticky', top: '0', backgroundColor: '#ffffff', zIndex: '1000', boxShadow: '0 2px 2px -1px rgba(0, 0, 0, 0.4)' }}>
                        <tr className="tblHdngOne">
                            <th>S.no</th>
                            <th>UDISE_ID</th>
                            <th>School Name</th>
                            <th>District</th>
                            <th>Block/Ward no.</th>
                            <th>No. of Trees</th>
                          
                        </tr>
                    </thead>
                    <tbody>
                        {eventsData && eventsData.length > 0 ? (
                            eventsData.map((item, i) => (
                                <tr key={item._id}>
                                    <td>{(currentPage - 1) * 10 + i + 1}</td>
                                    <td>{item.udiseId || 'N/A'}</td>
                                    <td>{item.schoolName || "-"}</td>
                                    {/* <td>{item.studentName || "-"}</td> */}
                                    {/* <td>{item.fathersName || "-"}</td>
                                    <td>{item.mothersName || "-"}</td> */}
                                    {/* <td>{item.gender || "-"}</td> */}
                                    {/* <td>{item.participantAge || "-"}</td> */}
                                    {/* <td>{item.class || "-"}</td> */}
                                    {/* <td>{item.state || "-"}</td> */}
                                    <td>{item.district || "-"}</td>
                                    <td>{item.blockName || "-"}</td>
                                    {/* <td>{item.city || "-"}</td> */}
                                    
                                    {/* <td>{item.numberOfStudents || 0}</td> */}
                                    <td>{item.numberOfTrees || 0}</td>
                                    {/* <td>{item.participatingSchools || 0}</td> */}
                                    {/* <td>{item.certificatesGenerated || 0}</td> */}
                                    {/* <td>{Helper.formatDate(item.createdAt)}</td> */}
                                </tr>
                            ))
                        ) : (
                            <tr><td colSpan={17} className="text-center">Data not Found.</td></tr>
                        )}
                    </tbody>
                </table>

                {/* Footer can be updated to any aggregation if needed */}
                {/* <div className="stackHldrCntDiv">
                    <div className="row">
                        <div className="col-12 col-lg-6 stackLft animate__animated animate__fadeInLeft customWidth">
                            <h2 className="sbHdng">Key Statistics</h2>
                            <div className="stackLftIn">
                                <ul>
                                    <li>
                                        Total Students <span>{participantsTotal || 0}</span>
                                    </li>
                                    <li>
                                        Total Trees <span>{totalTrees || 0}</span>
                                    </li>
                                    <li>
                                        Participating Schools <span>{totalSchools || 0}</span>
                                    </li>
                                    <li>
                                        Certificates Generated <span>{totalCertificates || 0}</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div> */}

                {totalPages > 1 && (
                    <div className="mb-3">
                        <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>Previous</button>
                        <span>Page {currentPage} of {totalPages}</span>
                        <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>Next</button>
                    </div>
                )}
            </div>
        </div>
    </div>
</div>

        </>
    );
}

export default TreesDataViewTable;
